// Shared skyline hero animation — matches the Hotels page hero:
// a Cairo-inspired silhouette drawn in dark ink with a warm-gold echo tracing behind it.
const SkylineHero = ({ className = "opacity-25" }: { className?: string }) => (
  <div className={`absolute inset-0 flex items-center justify-center overflow-hidden ${className}`}>
    <svg
      className="w-full h-full"
      viewBox="0 0 1200 400"
      preserveAspectRatio="xMidYMid slice"
      fill="none"
    >
      <path
        d="M0,400 L0,320 L60,320 L60,250 L100,250 L100,320 L140,320 L140,190 L180,190 L180,320 L230,320 L230,150 L245,150 L245,120 L255,120 L255,150 L270,150 L270,320 L340,320 L340,260 C340,205 450,205 450,260 L450,320 L520,320 L520,140 L532,140 L532,320 L600,320 L600,240 L660,240 L660,320 L720,320 L720,170 L780,170 L780,320 L850,320 L850,260 C850,215 940,215 940,260 L940,320 L1010,320 L1010,190 L1070,190 L1070,320 L1140,320 L1140,250 L1200,250 L1200,400"
        stroke="hsl(var(--foreground))"
        strokeWidth="1.5"
        fill="none"
        className="animate-draw-skyline"
      />
      <path
        d="M0,400 L0,320 L60,320 L60,250 L100,250 L100,320 L140,320 L140,190 L180,190 L180,320 L230,320 L230,150 L245,150 L245,120 L255,120 L255,150 L270,150 L270,320 L340,320 L340,260 C340,205 450,205 450,260 L450,320 L520,320 L520,140 L532,140 L532,320 L600,320 L600,240 L660,240 L660,320 L720,320 L720,170 L780,170 L780,320 L850,320 L850,260 C850,215 940,215 940,260 L940,320 L1010,320 L1010,190 L1070,190 L1070,320 L1140,320 L1140,250 L1200,250 L1200,400"
        stroke="hsl(var(--hotel-primary))"
        strokeWidth="2"
        fill="none"
        className="animate-draw-skyline-hotels"
      />
    </svg>
  </div>
);

export default SkylineHero;
